<section class="create-invoice-form">
  @if (form) {
    <app-form-header (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  }
  @if (form) {
    <form class="create-invoice-form__form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <div class="astral-layout-item">
            <app-autocomplete-remote-paged
              [control]="form.controls['companyId']"
              [service]="companyService"
              [defaultSearch]="'*'"
              [enableInfiniteScroll]="true"
              (itemSelected)="onCompanySelected($event)"
            ></app-autocomplete-remote-paged>
          </div>
          <astral-date-picker [control]="form.controls['dueDate']"></astral-date-picker>
          <astral-date-picker [control]="form.controls['accountingDate']"></astral-date-picker>
          <astral-select [control]="form.controls['bankAccountId']" [itemsSource]="accountSelection"></astral-select>
        </astral-layout-group>
      </section>
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
          <app-autocomplete-remote
            [control]="debtorForm.controls['contactId']"
            [service]="filterService"
            (itemSelected)="onContactSelected($event)"
          ></app-autocomplete-remote>
          <astral-input [control]="debtorForm.controls['email']" [type]="'email'" [inputMode]="'email'"></astral-input>
          @if (allowAttest) {
            <astral-toggle [control]="form.controls['autoAttest']"></astral-toggle>
          }
        </astral-layout-group>
        @if (matchingLeaseAgreementsSelection) {
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
            <astral-select [control]="form.controls['leaseAgreementId']" [itemsSource]="matchingLeaseAgreementsSelection"></astral-select>
          </astral-layout-group>
        }
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <app-invoice-delivery-method
            [control]="form.controls['deliveryMethod']"
            [company]="form.controls['companyId'].value"
            [payer]="debtorForm.controls['contactId'].value"
            [helpText]="'INVOICE.HELP_TEXT.DELIVERY_METHOD'"
          ></app-invoice-delivery-method>
          <astral-input [control]="form.controls['labeling']"></astral-input>
        </astral-layout-group>
      </section>
      <section class="astral-section-surface astral-stack-m">
        <h3 class="astral-section-heading">{{ 'INVOICE.PREVIEW.INVOICE_ADDRESS' | translate }}</h3>
        <app-postal-address
          [group]="addressForm"
          [model]="addressModel"
          [mandatory]="true"
          [title]="null"
          [showName]="true"
          [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
        ></app-postal-address>
      </section>
      <section class="astral-section-surface astral-stack-m">
        <h3 class="astral-section-heading">{{ 'INVOICE_ROW.HEADER' | translate }}</h3>
        @if (rowsDataContext) {
          <div>
            <app-invoice-row-list
              [dataContext]="rowsDataContext"
              (invoiceRowCreate)="invoiceRowCreated($event)"
              (invoiceRowChange)="invoiceRowChanged($event)"
              (invoiceRowDelete)="invoiceRowDeleted($event)"
              (invoiceRowsReorder)="invoiceRowReordered()"
            ></app-invoice-row-list>
          </div>
        }
        <app-file-upload
          [forms]="appendixes"
          [text]="'COMMON.ATTACH_PDF_FILE'"
          [allowedMimeTypes]="mimeTypes"
          [buttonVariant]="'primary'"
          [buttonSize]="'small'"
          [icon]="'pdf'"
        ></app-file-upload>
      </section>
    </form>
  }
</section>
